import React, { Component } from 'react';
import clsx from 'clsx';

import Events from './Events';
import Notifications from './Notifications';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { updateUserToState } from '../utils';
import withFeature from '../FeatureFlag/WithFeature.js';
import EventSending from './EventSending';
import { PricingModuleContextConsumer } from '../../context/contexts/PricingModuleContext';

class SystemNotifications extends Component {
    state = {
        isLoading: true,
        showEventSendingModal: false
    };

    componentDidMount() {
        updateUserToState(this, () => {
            this.setState({ isLoading: false });
        });
    }

    render() {
        return (
            <div id="notifications">
                {this.state.isLoading && (
                    <div className="silverfort-loader">
                        <div className="logo"></div>
                    </div>
                )}
                {!this.state.isLoading && (
                    <div className="pt-16">
                        <PricingModuleContextConsumer>
                            {({ isCloudOnly }) => (
                                <div id="page-wrapper" className="page-wrapper">
                                    <div className="events-settings-container">
                                        <div
                                            className={clsx('events-settings', isCloudOnly && 'mt-3')}
                                            onClick={() => this.setState({ showEventSendingModal: true })}>
                                            <i className="fa fa-cog cog-icon"></i>
                                        </div>
                                    </div>
                                    {!isCloudOnly &&
                                        withFeature({
                                            featureKey: FEATURE_FLAGS_NAMES.SystemMode,
                                            featureName: 'systemMode',
                                            predicate: (systemMode) => systemMode !== undefined
                                        })(Notifications)({ ...this.props })}
                                    {withFeature({
                                        featureKey: FEATURE_FLAGS_NAMES.SystemMode,
                                        featureName: 'systemMode',
                                        predicate: (systemMode) => systemMode !== undefined
                                    })(Events)({ ...this.props, isCloudOnly })}
                                </div>
                            )}
                        </PricingModuleContextConsumer>
                    </div>
                )}
                {this.state.showEventSendingModal && (
                    <EventSending
                        open={this.state.showEventSendingModal}
                        onClose={() => this.setState({ showEventSendingModal: false })}
                    />
                )}
            </div>
        );
    }
}

export default SystemNotifications;
